import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, UserCheck, Award } from 'lucide-react';
const advantages = [{
  icon: <Sparkles strokeWidth={1} size={40} data-id="element-39" />,
  title: 'Преміальні матеріали',
  description: "Використовую лише перевірену косметику світових брендів, щоб зберегти здоров'я та природний блиск вашого волосся."
}, {
  icon: <UserCheck strokeWidth={1} size={40} data-id="element-40" />,
  title: 'Індивідуальний підхід',
  description: 'Підбираю форму стрижки та відтінок фарбування, враховуючи ваші риси обличчя, структуру волосся та стиль життя.'
}, {
  icon: <Award strokeWidth={1} size={40} data-id="element-41" />,
  title: 'Багаторічний досвід',
  description: "Понад 12 років безперервної практики та регулярне підвищення кваліфікації у кращих майстрів б'юті-індустрії."
}];
export function Advantages() {
  return <section className="py-24 bg-white" data-id="element-42">
      <div className="container mx-auto px-6 md:px-12" data-id="element-43">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-44">
          <h2 className="font-heading text-4xl md:text-5xl text-dark mb-4" data-id="element-45">
            Чому обирають мене?
          </h2>
          <div className="w-12 h-px bg-accent mx-auto" data-id="element-46"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-47">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="border-t border-gray-200 pt-8" data-id="element-48">
              <div className="text-accent mb-6 opacity-80" data-id="element-49">{adv.icon}</div>
              <h3 className="text-xl font-medium text-dark mb-4 tracking-wide" data-id="element-50">
                {adv.title}
              </h3>
              <p className="text-gray-500 font-light text-sm leading-relaxed" data-id="element-51">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}